<div id="solicitate-cae-container">
  <ng-container *ngIf="this.dialog1">
    <p class="subheading-01-semi-bold">
      Al solicitar el CAE, estás emitiendo las facturas de los agentes
      seleccionados en el paso anterior. Si estás de acuerdo presioná el botón
      solicitar CAE.
    </p>
    <div id="check-container">
      <mat-checkbox
        id="email-agent"
        class="check"
        [checked]="this.checkAgent"
        color="primary"
        (change)="changeAgent($event)"
      >
        <p class="subheading-01-regular">
          Enviar copia de la factura a los agentes por e-mail
        </p>
      </mat-checkbox>
      <mat-checkbox
        id="email-user"
        class="check"
        [checked]="this.checkUser"
        color="primary"
        (change)="changeUser($event)"
        ><p class="subheading-01-regular">
          Deseo recibir una copia de las facturas por e-mail
        </p>
      </mat-checkbox>
    </div>
  </ng-container>
  <ng-container *ngIf="this.dialog2">
    <p class="subheading-01-semi-bold" id="bold">
      Solicitaste con éxito {{ this.quantity }} facturas a AFIP por un total de
      ${{ this.total | number : "1.0-2" : "es-AR" }}
    </p>
    <div id="img-container">
      <div id="cae-img"></div>
    </div>
  </ng-container>
</div>
